import { ActionIconsContainer } from "../../../../shared/GeneralStyles";
import Row  from "../../../../kit/Row";
import TableActions from "../../../../shared/TableActions";
import StatementHandler from "../../../../utils/methods/StatementHandler";
import {
  ImageContainer, ImageContainerRow,
} from "../../globalStyle";
import {Badge, Icon, Chip} from "@mui/material";
const { REACT_APP_API_URL } = process.env;
const CoursesTableConfig = (UpdateMaster, DeleteMaster ,DetailMaster) => {
  return {
    showHeader: true,

    row: [
      {
        headerTitle: "ردیف",
        displayTitle: "rowIndex",
        size: 1,
        responsiveShow: true,
        element: (props) => {
          return <Row>{props.index + 1}</Row>;
        },
      },
      {
        headerTitle: "تصویر",
        displayTitle: "image",
        size: 1,
        responsiveShow: true,
        element: (props) => {
          return (
            <ImageContainerRow src={REACT_APP_API_URL + "/" + props.row.image} />
          );
        },
      },
      {
        headerTitle: "نام درس ",
        displayTitle: "fa_title",
        size: 3,
        responsiveShow: true,
        element: (props) => {
          return (
            <Row > {StatementHandler.StatementSplitter(props.row.fa_title, 40)} </Row>
          );
        },
      },
      {
        headerTitle: "امتیاز",
        displayTitle: "rate",
        size: 2,
        responsiveShow: true,
        element: (props) => {
          return (
            <Row>
              {props.row.rate !=="" ? props.row.rate : "-"}
            </Row>
          );
        },
      },
    
      {
        headerTitle: "قیمت",
        displayTitle: "price",
        size: 2,
        responsiveShow: true,
        element: (props) => {
          return (
            <Row>
              {props.row.price_unit+ " "+props.row.price}
            </Row>
          );
        },
      },
      // {
      //   headerTitle: "ظرفیت دانشجو",
      //   displayTitle: "student_capacity",
      //   size: 2,
      //   responsiveShow: true,
      //   element: (props) => {
      //     return (
      //       <Row>
      //         {props.row.student_capacity !=="" ? props.row.student_capacity : "-"}
      //       </Row>
      //     );
      //   },
      // },
      //  {
      //   headerTitle: "ظرفیت باقیمانده",
      //   displayTitle: "remaining_capacity",
      //   size: 2,
      //   responsiveShow: true,
      //   element: (props) => {
      //     return (
      //       <Row>
      //         {props.row.remaining_capacity !=="" ? props.row.remaining_capacity : "-"}
      //       </Row>
      //     );
      //   },
      // },
      
      {
        headerTitle: "وضعیت",
        displayTitle: "status",
        size: 2,
        responsiveShow: true,
        element: (props) => {
          return (
            <Row>
              <Chip label={props.row.status === "" ? "-" : props.row.status} variant="filled"
                    color={props.row.status === "active" ? "success" : "default"} />
            </Row>
          );
        },
      },  {
        headerTitle: "استاد",
        displayTitle: "",
        size: 2,
        responsiveShow: true,
        element: (props) => {
          return (
            <Row>
              {props.row.master.fa_last_name !== "" ? props.row.master.fa_last_name : "-"}
            </Row>
          );
        },
      },  {
        headerTitle: "تاریخ شروع",
        displayTitle: "start_date_fa",
        size: 2,
        responsiveShow: true,
        element: (props) => {
          return (
            <Row>
              {props.row.start_date_fa !=="" ? props.row.start_date_fa : "-"}
            </Row>
          );
        },
      },
      
      {
        headerTitle: "عملیات",
        displayTitle: "id",
        size: 2,
        responsiveShow: false,
        element: (props) => {
          return (
            <ActionIconsContainer>
              <TableActions
                type="edit"
                onClick={() => {
                  UpdateMaster(props.row);
                }}
              />
              <TableActions
                type="delete"
                onClick={() => {
                  DeleteMaster(props.row);
                }}
              />
                <TableActions
                type="detail"
                onClick={() => {
                  DetailMaster(props.row);
                }}
              />
            </ActionIconsContainer>
          );
        },
      },
    ],
  };
};
export default CoursesTableConfig;
